import { SET_CARD_DATA } from 'js/store/cards/Cards.actions.js';

import { parseCardsData } from '../cards/Cards.parser.js';

const initState = {
  byId: {},
  allIds: [],
  searchIndexes: {},
  curatedCollections: { allIds: [], byId: {} },
};

const cards = (state = initState, action) => {
  let nextState = {};

  switch (action.type) {
    case SET_CARD_DATA: {
      const { searchIndexes, byId, allIds, curatedCollections } = parseCardsData(action.payload);
      nextState.searchIndexes = searchIndexes;
      nextState.byId = byId;
      nextState.allIds = allIds;
      nextState.curatedCollections = curatedCollections;
      return { ...state, ...nextState };
    }

    default:
      break;
  }
  return state;
};

export default cards;
